import { Routes } from '@angular/router';
import { authGuard } from '@core/guards/auth-guard';
import { guestGuard } from '@core/guards/guest-guard';

export const routes: Routes = [
  {
    path: 'auth',
    canActivate: [guestGuard],
    loadComponent: () => import('@core/layout/auth-layout/auth-layout'),
    loadChildren: () => import('@core/auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('@core/layout/main-layout/main-layout'),
    children: [
      {
        path: '',
        loadChildren: () => import('@features/event/event.routes').then((m) => m.eventRoutes),
      },
      {
        path: 'conversation',
        loadComponent: () => import('@features/conversation/conversation'),
        loadChildren: () => import('@features/conversation/conversation.routes').then((m) => m.conversationRoutes),
      },
    ],
  },
];
